import dayjs from 'dayjs'
import { IMeeetingAgenda } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { toFormat } from 'core/classes/helpers/DateHelper'

export const getChangedAgendaSchedule = (meetingDataTime: string, data: IMeeetingAgenda[]) => {
  const updatedArr: IMeeetingAgenda[] = []
  for (let index = 0; index < data.length; index++) {
    const el = data[index]
    if (index === 0) {
      updatedArr[index] = {
        ...el,
        Schedule: {
          Start: meetingDataTime || null,
          End: meetingDataTime
            ? toFormat(dayjs(meetingDataTime).add(el.Time, 'm'), 'YYYY-MM-DDTHH:mm:ss')
            : null,
        },
      }
      continue
    }

    const start: string | null = updatedArr[index - 1]?.Schedule?.End
    const end: string | null = start
      ? toFormat(dayjs(start).add(el.Time, 'm'), 'YYYY-MM-DDTHH:mm:ss')
      : null

    updatedArr[index] = { ...el, Schedule: { Start: start, End: end } }
  }

  return updatedArr
}
